module.exports = __webpack_public_path__ + "img/resource02.612300ba.png";